import { type ReactNode } from 'react';

import { Divider, Typography, Box, Stack } from '@cast/design-system';

const LABEL_WIDTH = 167;

export const MetaDetailRow = ({
  label,
  children,
  testId,
}: {
  label: string;
  children?: ReactNode;
  testId?: string;
}) => (
  <Stack
    direction="row"
    gap={40}
    alignItems="flex-start"
    data-testid={testId}
    width="100%"
  >
    <Typography variant="P12M" sx={{ width: LABEL_WIDTH, flexShrink: 0 }}>
      {label}
    </Typography>
    <Box flex={1} minWidth={0}>
      {children}
    </Box>
  </Stack>
);

export const MetaDetailRows = ({ children }: { children: ReactNode }) => (
  <Stack gap={6} divider={<Divider />} width="100%">
    {children}
  </Stack>
);
